import { createAxiosInstance } from '../../utils/helpers'
import axios from 'axios'
import Cookies from 'universal-cookie'
import querystring from 'querystring'
import { API_URL } from '../../utils/constants'
import * as types from '../../types'
import history from '../../utils/history'

import { displayMessages } from '../Layout/actions'

const cookies = new Cookies()

export function signIn({ username, password }) {
    return function (dispatch) {
        const fn0 = d => d({ type: types.SIGNIN_PROCESANDO, payload: true  })
        fn0(dispatch)

        const data = querystring.stringify({
            username: username,
            password: password
        })

        axios
            .post(`${API_URL}/account/signin`, data)
            .then((res) => {
                cookies.set('token', res.data.access_token, { path: '/' })
                const fn1 = d => d({ type: types.SIGNIN_INICIAR_SESION })
                fn1(dispatch)
                history.push(window.FOLDER + '/')
            })
            .catch((err) => {
                const fn5 = d => d({ type: types.SIGNIN_PROCESANDO, payload: false  })
                fn5(dispatch)
                if (err.response && err.response.status === 401) {
                    dispatch({type: types.LAYOUT_MOSTRAR_MENSAJE, payload: { type: 'danger', message: 'Nombre de usuario o contraseña incorrectas' }})
                } else {
                    displayMessages(dispatch, err)
                }
            })
    }
}

export function signOut() {
    const axiosWithToken = createAxiosInstance()
    return function (dispatch) {
        if (axiosWithToken) {
            axiosWithToken.get(`${API_URL}/account/signout`)
            .then((res) => {
                cookies.remove('token', { path: '/' })
                dispatch({ type: types.SIGNIN_CERRAR_SESION })
                history.push(window.FOLDER + '/signin')
            })
            .catch((err) => {
                cookies.remove('token', { path: '/' })
                dispatch({ type: types.SIGNIN_CERRAR_SESION })
                history.push(window.FOLDER + '/signin')
            })

        } else {
            cookies.remove('token', { path: '/' })
            dispatch({ type: types.SIGNIN_CERRAR_SESION })
            history.push(window.FOLDER + '/signin')
        }
    }
}

export function getUserFromToken(){
    const axiosWithToken = createAxiosInstance()
    return axiosWithToken.get(`${API_URL}/account/user`)
    .then((res) => {
        const data = res.data
        data.user.fullname = `${data.user.name} ${data.user.lastname}`
        data.modulos.push({
            cadena_ejecucion: "root",
            cod_modulo_hijo: null,
            parent_module_id: null,
            cod_nodo: 9999,
            cod_rol: null,
            nom_modulo: "root",
            config: { menu: 1 }
        })

        const objDict = data.modulos.reduce(function(p,c) {
            if (c.nom_modulo !== "root" && c.parent_module_id === null) c.parent_module_id = 9999
            p[c.cod_nodo] = c
            c.submodulos = []
            return p
        }, {})

        const modulos = data.modulos.reduce(function(p,c) {
            if (!c.parent_module_id) {
                p = c
            } else {
                objDict[c.parent_module_id].submodulos.push(c)
            }
            return p
        }, {})
        data.user.modulos = modulos.submodulos
        data.user.elementos = data.elementos

        return data.user
    })
    .catch((err) => {
        throw err
    })
}